import type { ReactNode } from 'react'
import { ScrollView } from '@/components/ScrollView'
import { ContentLoading } from '@/components/ContentLoading'
import styles from './JobCreationFormView.module.css'

export interface JobCreationFormViewProps {
  children?: ReactNode
  isLoading?: boolean
}

export function JobCreationFormView({
  children,
  isLoading,
}: JobCreationFormViewProps) {
  return (
    <ScrollView>
      <div>
        <div className={styles.root}>
          {children}
          {isLoading && (
            <div className={styles.loading}>
              <ContentLoading size="section" />
            </div>
          )}
        </div>
      </div>
    </ScrollView>
  )
}
